import script from "./AppSidebarLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppSidebarLayout.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__